class LazyLoadingImage {
    static attach() {
        const preloadImages = document.querySelectorAll("[data-lazyload='preload']");
        const delayImages = document.querySelectorAll("[data-lazyload='delay']");

        if ("IntersectionObserver" in window) {
            const callback = function (entries, observer) {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        img.src = img.getAttribute("data-src");
                        observer.unobserve(img);
                    }
                });
            };

            // ビューポートの高さを取得
            const viewportHeight = window.innerHeight;
            const optionsForPreload = {
                root: null, // ビューポートを基準にする
                rootMargin: `0px 0px ${viewportHeight}px 0px`, // 1画面分先読みする
                threshold: 0
            };
            const optionsFordelay = {
                root: null,
                rootMargin: `0px 0px 0px 0px`,
                threshold: 0
            };

            const observerForPreload = new IntersectionObserver(callback, optionsForPreload);
            const observerFordelay = new IntersectionObserver(callback, optionsFordelay);

            preloadImages.forEach((img) => {
                observerForPreload.observe(img);
            });
            delayImages.forEach((img) => {
                observerFordelay.observe(img);
            });
        } else {
            // IntersectionObserver がサポートされていない場合のフォールバック
            preloadImages.forEach((img) => {
                // eslint-disable-next-line no-param-reassign
                img.src = img.getAttribute("data-src");
            });
            delayImages.forEach((img) => {
                // eslint-disable-next-line no-param-reassign
                img.src = img.getAttribute("data-src");
            });
        }
    }
}

export { LazyLoadingImage };
